import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Periodo } from '../model/periodo';

@Injectable({
  providedIn: 'root'
})
export class PeriodoService {

  url = `${environment.host}/api/periodo`;

  constructor(private http: HttpClient) { }

  obtenerperiodos(): Observable<Periodo[]> {
    return this.http.get<Periodo[]>(`${this.url}/obtener/lista`);
  }
}
